import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useFormik } from 'formik';
import utilsService, { TOAST_TYPE } from '../../helpers/utils'
//import * as XLSX from 'xlsx/xlsx';
import XLSX from 'sheetjs-style';
import TextInput from '../../shared/Fields/TextInput';
import st26service, { convertFastaForParsedXml } from '../../services/st26service';
import { useSelector } from 'react-redux';


const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        width: '96%',
        margin: '0 auto 28px',
        minHeight: '260px',
        // borderBottom: '1px solid #cec7c7',
        padding: '23px 16px 14px',
    },
    headerPipe: {
        margin: '0 10px'
    },
    searchInput: {
        width: '30%'
    },
    buttonStyleCancel: {
        float: 'right',
        textTransform: 'none',
        margin: '4px',
        color: 'white',
        backgroundColor: '#008EC5 !important',
        border: '1px solid #1F4E79 !important',
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        }
    },

    antibodyNumInput: {
        width: '8%'
    }, 

    colorConDSI: {
        backgroundColor: 'gainsboro',
        // marginTop: '-38px',
        padding: '28px',
        paddingTop: '28px',
        paddingBottom: '65px',
        // marginLeft: '7px',
        // marginRight: '7px',
        paddingRight: '10px',
        borderRadius: '5px',
    },
    modalBody: {
        paddingBottom: '20px'
    },
    footerDiv: {
        padding: '0 10px'
    },
    loginSubmitCancel: {
        backgroundColor: '#0182C5',
        borderColor: '#1F4E79',
        border: '1px solid #1F4E79',
        color: 'white',
        margin: '4px',
        textTransform: 'capitalize',
        '&:hover': {
        backgroundColor: '#0182C5',
        boxShadow: 'none',
        },
    },
    modaltext: {
        position: 'absolute',
        top: '10px',
        right: '10px'
    },
    modalClassConDSI: {
        position: 'absolute',
        width: '96%',
        padding: '35px 15px 15px',
        // height: 'auto',
        // top: '30%',
        // left: '50%',
        right: 'auto',
        bottom: 'auto',
        // transform: 'translate(-50%, -50%)'
    },
    modalBoxContent: {
        maxHeight: '675px',
    },
    FastaBtn: {
        margin: '4px 0 0 8px !important',
        textTransform: 'none !important',
        backgroundColor: '#db862c !important',
        border: '1px solid #ca751b !important',
        color: 'white !important',
    },
    cancelbutton:{
        backgroundColor: '#EEEEEE !important',
        border: '1px solid #CCCCCC !important',
        
        margin: '4px 0 !important',
        textTransform: 'none !important',
        marginTop: '4px !important',
        color: '#777777 !important',
        boxSshadow: 'none !important',
    },
    CancelButtonDisble: {
        backgroundColor: '#EEEEEE !important',
        border: '1px solid #CCCCCC !important',
        
        margin: '4px 6px 0 !important',
        textTransform: 'none !important',
        color: '#777777 !important',
        boxSshadow: 'none !important',
    },
    downloadFastaButton: {
        backgroundColor: '#EEEEEE !important',
        border: '1px solid #CCCCCC !important',
        
        margin: '4px 0 !important',
        textTransform: 'none !important',
        marginTop: '4px !important',
        color: '#777777 !important',
        boxSshadow: 'none !important',
    }

}));

var ExcelExportArray =[];
function TabularToFasta() {
    const { t, i18n } = useTranslation('common');

    const classes = useStyles();
    const history = useHistory();
    const [authInfo, setAuthInfo] = useState();
    const [formdata, setFormData] = useState({});
    const { workflowId } = useParams();
    const toastRef = useRef();
    const [modalShow, setModalShow] = React.useState(false);
    const [jsonData, setJsonData] = useState('');
    const [file, setFile] = useState(null);
    const [fileData, setFileData] = useState(null);
    const toggle = useSelector(state => state.setToggle.toggle);
    const userInfo = useSelector(state => state.setUserInfo);  
    const handleConvertAndSendToParsedXml = async () => {
        if (jsonData) {
            try {
                // Clean the FASTA data to remove descriptions, keeping only headers and sequences
                const cleanedFasta = jsonData.split('\n').map(line => {
                    if (line.startsWith('>')) {
                        // Extract only the sequence ID (first part before any space/description)
                        const parts = line.split(' ');
                        return parts[0]; // Return just ">SeqID" without description
                    }
                    return line; // Keep sequence lines as they are
                }).join('\n');

                console.log('Original FASTA data:', jsonData); // Debug log
                console.log('Cleaned FASTA data:', cleanedFasta); // Debug log

                // Call the convertFastaForParsedXml function with the cleaned data
                const result = await convertFastaForParsedXml({st26input: cleanedFasta}, history, t);
                
                console.log('Conversion result:', result); // Debug log
                
                if (result === 'parsererror') {
                    utilsService.showToast(toastRef, 'Error parsing FASTA data', TOAST_TYPE.ERROR);
                } else if (result === 'empty') {
                    utilsService.showToast(toastRef, 'No sequence data found', TOAST_TYPE.ERROR);
                } else {
                    console.log('Navigating to ParsedXml with data:', result); // Debug log
                    // Navigate to ParsedXml with the converted data and source information
                    history.push({
                        pathname: '/parsedxml',
                        state: {
                            sequences: result,
                            source: 'Tabular'
                        }
                    });
                }
            } catch (error) {
                console.error('Error converting and sending to ParsedXml:', error);
                utilsService.showToast(toastRef, 'Error processing sequences', TOAST_TYPE.ERROR);
            }
        }
    };

    const handleIpSequenceSearch = () => {
        if (jsonData) {
            // Parse and classify sequences like in ConvertSequenceFasta.js
            const lines = jsonData.split('\n');
            const sequences = [];
            let currentHeader = '';
            let currentSeq = '';
            
            for (let line of lines) {
                line = line.trim();
                if (line.startsWith('>')) {
                    if (currentHeader && currentSeq) {
                        sequences.push({ header: currentHeader, sequence: currentSeq });
                    }
                    currentHeader = line;
                    currentSeq = '';
                } else if (line) {
                    currentSeq += line;
                }
            }
            if (currentHeader && currentSeq) {
                sequences.push({ header: currentHeader, sequence: currentSeq });
            }
            
            // Classify sequences
            const classifiedSequences = sequences.map((seq, index) => {
                const cleanSeq = seq.sequence.replace(/\s/g, '').toUpperCase();
                const proteinOnlyAA = /[EFHIJKLMPQRSVWYZ]/i.test(cleanSeq);
                const onlyNucleotides = /^[ATGCUN]+$/i.test(cleanSeq);
                const nucleotideBases = (cleanSeq.match(/[ATGCU]/gi) || []).length;
                const nucleotideRatio = nucleotideBases / cleanSeq.length;
                
                let isProtein = false;
                if (proteinOnlyAA) {
                    isProtein = true;
                } else if (onlyNucleotides) {
                    isProtein = false;
                } else if (nucleotideRatio > 0.9) {
                    isProtein = false;
                } else {
                    isProtein = true;
                }
                
                return {
                    header: `>SEQ_NO_${(index + 1).toString().padStart(4, '0')}`,
                    sequence: seq.sequence,
                    isProtein: isProtein
                };
            });
            
            const proteinCount = classifiedSequences.filter(seq => seq.isProtein).length;
            const nucleotideCount = classifiedSequences.filter(seq => !seq.isProtein).length;
            const defaultType = proteinCount >= nucleotideCount ? "protein" : "nucleotide";
            
            const proteinSeqs = classifiedSequences
                .filter(seq => seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
                
            const nucleotideSeqs = classifiedSequences
                .filter(seq => !seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            const combinedSeqs = classifiedSequences
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            history.push({
                pathname: '/ipseqsearch',
                state: {
                    seq: combinedSeqs,
                    type: defaultType,
                    proteinSeqs: proteinSeqs,
                    nucleotideSeqs: nucleotideSeqs,
                    proteinCount: proteinCount,
                    nucleotideCount: nucleotideCount
                }
            });
        }
    };

    const handleSequenceVariationSearch = () => {
        if (jsonData) {
            // Parse and classify sequences like in ConvertSequenceFasta.js
            const lines = jsonData.split('\n');
            const sequences = [];
            let currentHeader = '';
            let currentSeq = '';
            
            for (let line of lines) {
                line = line.trim();
                if (line.startsWith('>')) {
                    if (currentHeader && currentSeq) {
                        sequences.push({ header: currentHeader, sequence: currentSeq });
                    }
                    currentHeader = line;
                    currentSeq = '';
                } else if (line) {
                    currentSeq += line;
                }
            }
            if (currentHeader && currentSeq) {
                sequences.push({ header: currentHeader, sequence: currentSeq });
            }
            
            // Classify sequences
            const classifiedSequences = sequences.map((seq, index) => {
                const cleanSeq = seq.sequence.replace(/\s/g, '').toUpperCase();
                const proteinOnlyAA = /[EFHIJKLMPQRSVWYZ]/i.test(cleanSeq);
                const onlyNucleotides = /^[ATGCUN]+$/i.test(cleanSeq);
                const nucleotideBases = (cleanSeq.match(/[ATGCU]/gi) || []).length;
                const nucleotideRatio = nucleotideBases / cleanSeq.length;
                
                let isProtein = false;
                if (proteinOnlyAA) {
                    isProtein = true;
                } else if (onlyNucleotides) {
                    isProtein = false;
                } else if (nucleotideRatio > 0.9) {
                    isProtein = false;
                } else {
                    isProtein = true;
                }
                
                return {
                    header: `>SEQ_NO_${(index + 1).toString().padStart(4, '0')}`,
                    sequence: seq.sequence,
                    isProtein: isProtein
                };
            });
            
            const proteinCount = classifiedSequences.filter(seq => seq.isProtein).length;
            const nucleotideCount = classifiedSequences.filter(seq => !seq.isProtein).length;
            const defaultType = proteinCount >= nucleotideCount ? "protein" : "nucleotide";
            
            const proteinSeqs = classifiedSequences
                .filter(seq => seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
                
            const nucleotideSeqs = classifiedSequences
                .filter(seq => !seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            const combinedSeqs = classifiedSequences
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            history.push({
                pathname: '/ipseqvariation',
                state: {
                    seq: combinedSeqs,
                    type: defaultType,
                    proteinSeqs: proteinSeqs,
                    nucleotideSeqs: nucleotideSeqs,
                    proteinCount: proteinCount,
                    nucleotideCount: nucleotideCount
                }
            });
        }
    };

    const handleConvert = () => {
    // Get tabular text either from file or from textarea
    const processTabularText = (excelText) => {
        // Validate if it's a proper sequence table
        if (!looksLikeFastaTable(excelText)) {
            utilsService.showToast(TOAST_TYPE.ERROR, 'Error in parsing FASTA data', toastRef);
            return;
        }

        // Convert to FASTA
        const json = excelText.split('\n').map(line => {
            const parts = line.split('\t').map(part => part.trim());
            if (parts.length >= 3) {
            const seqid = parts[0];
            const description = parts[1];
            const sequence = parts.slice(2).join('').replace(/\s+/g, '');
            return `>${seqid} ${description}\n${sequence}`;
            } else if (parts.length === 2) {
            const seqid = parts[0];
            const sequence = parts[1].replace(/\s+/g, '');
            return `>${seqid}\n${sequence}`;
            }
            return '';
        }).filter(Boolean).join('\n');

        setJsonData(json);
        formik.setFieldValue("st26input", json);
    };

    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const excelText = XLSX.utils.sheet_to_csv(worksheet, { FS: '\t' });
        processTabularText(excelText);
        };
        reader.readAsArrayBuffer(file);
    } else if (formik.values.st26input1) {
        // Use text from textarea (copy-paste case)
        processTabularText(formik.values.st26input1);
    }
    };
    
    const resetFileName = () => {
        var fileInput = document.querySelector('input[type=file]');
        if (fileInput) {
            fileInput.value = ''; // Clear the file input
        }
        setFile(null); // Reset the uploaded file state
    };
      

    function downloadFasta(json, file) {
        var blob = new Blob([json], {
            type: "text/plain;charset=utf-8;"
        });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        if (file && file.name) {
            a.download = file.name + '.fasta.txt';
        } else {
            // If the file name is not available, prompt the user for a name
            var fileName = prompt("Please enter the name of the file:");
            if (fileName) {
                // If the user provides a name, use it for the download
                a.download = fileName + '.fasta.txt';
            } 
        }
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        history.push('/convertsequence');
    }
    

    function cncl() {
        history.push('/home');
    }

    const formik = useFormik({
        initialValues: {
            st26input: formdata.st26input,
            st26input1: formdata.st26input1
        },
        enableReinitialize: true,
        onSubmit: async (values) => {
            let { st26input } = values;

        }
    });

    function looksLikeFastaTable(text) {
        const lines = text.split('\n').filter(l => l.trim() !== '');
        if (lines.length < 1) return false;  // At least one line space is needed

        let sequenceLines = 0;
        for (const line of lines) {
            const parts = line.split('\t').map(p => p.trim());
            // Sequence should be in the last column
            const seq = parts[parts.length - 1] || '';
            if (/^[ATGCUatgcuNRYSWKMBDHVefilpqrvwxyz\-\*]+$/i.test(seq) && seq.length >= 1) {
                sequenceLines++;
            }
        }
        return sequenceLines > 0;
    }

    // console.log(formik.values.st26input1, "values");

    function showfil(event) {
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            var fileInput = event.target.files[0];
            if (fileInput) {
                setFile(fileInput); // Update the file state with the selected file
                var reader = new FileReader();

                 if (fileInput.type === 'application/vnd.ms-excel' || fileInput.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    // Handle Excel file
                    reader.onload = function (event) {
                        const data = new Uint8Array(event.target.result);
                        const workbook = XLSX.read(data, { type: "array" });
                        const sheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[sheetName];
                        const excelData = XLSX.utils.sheet_to_csv(worksheet, { FS: '\t' });
                        // Set the value via formik (controlled component)
                        formik.setFieldValue("st26input1", excelData);
                    };
                    reader.readAsArrayBuffer(fileInput);
                } else {
                    utilsService.showToast(TOAST_TYPE.ERROR, 'Unsupported file format!', toastRef);
                }
            } else {
                alert('Please select a file before attempting to read it.');
            }
        } else {
            alert('Your browser is too old to support HTML5 File API');
        }
    }
    
    
    return (
        <div className={classes.grow}>
            <div ref={toastRef}></div>
            { jsonData && <form name="antibodySearchForm" onSubmit={formik.handleSubmit} className={classes.loginDiv}>

                <Row>
                    <Col lg="12" md="12" className={"mb-2 " + (authInfo && !authInfo.syscontrol_search_submit ? 'd-block' : 'd-none')}>
                        <Typography className="text-danger">
                            {t('ABsearchDisableText')}
                            {authInfo && authInfo.syscontrol_search_submit_txt}
                            {t('patienceThanksText')}</Typography>
                    </Col>

                    <Col lg="12" md="12" className="mb-2">
                        <h6 className={"appTextColor loginTitle"}>Fasta Sequence Input</h6>
                        <Row className="mb-3">

                            <Col lg="12" md="12" className="p-0 content float-left">
                                <div className="form-group px-3 ">
                                    <TextInput
                                        spellcheck="false"
                                        rows="20"
                                        multiline={true}
                                        fullWidth
                                        id="tabularInput"
                                        name="tabularInput"
                                        label="Copy and Paste your Fasta sequences here"
                                        variant="outlined"
                                        value={formik.values.st26input}
                                        onChange={(event) => {
                                            formik.handleChange(event);
                                            if (!event.target.value) {
                                                resetFileName(); // Clear file input when text input is cleared
                                            }
                                        }}                                        
                                        error={formik.touched.st26input && Boolean(formik.errors.st26input)}
                                        helperText={formik.errors.st26input}
                                    //disabled={authInfo && authInfo.redo}
                                    />
                                </div>

                            </Col>

                        </Row>
                        <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                    </Col>
                    

                     
                </Row>
                <Button
                        className={classes.FastaBtn}
                        color="default"
                        type="submit"
                        disableRipple={true}
                        variant="contained"
                        onClick={() => downloadFasta(jsonData, file)}// Change the desired file name here
                    >
                        Download Fasta Text File
                </Button>
                <Button
                        className={classes.FastaBtn}
                        color="default"
                        disableRipple={true}
                        variant="contained"
                        onClick={handleIpSequenceSearch}
                        style={{marginRight: '10px !important'}}
                    >
                        IP Sequence Search
                </Button>
                <Button
                        className={
                            (!jsonData || userInfo.vmAccess === false) 
                                ? classes.CancelButtonDisble  // Disabled style when no access
                                : classes.FastaBtn            // Enabled style when access granted
                        }
                        color="default"
                        disableRipple={true}
                        variant="contained"
                        onClick={handleSequenceVariationSearch}
                        style={{marginRight: '10px !important'}}
                        disabled={!formik.values.st26input || userInfo.vmAccess === false}
                    >
                        Sequence Variation Search
                </Button>                
                <Button variant="contained" disableRipple={true} color="default" className={classes.buttonStyleCancel}  onClick={cncl}>{t('cancel')}</Button>

            </form> 
            }
            { !jsonData &&  
            <form>
            
                <Row>
                    <Col lg="12" md="12" className={"mb-2 " + (authInfo && !authInfo.syscontrol_search_submit ? 'd-block' : 'd-none')}>
                        <Typography className="text-danger">
                            {t('ABsearchDisableText')}
                            {authInfo && authInfo.syscontrol_search_submit_txt}
                            {t('patienceThanksText')}</Typography>
                    </Col>

                    <Col lg="12" md="12" className="mb-2">
                        <h6 className={"appTextColor loginTitle"}>Tabular Sequence Input</h6>
                        <Row className="mb-3">

                            <Col lg="12" md="12" className="p-0 content float-left">
                                <div className="form-group px-3 ">
                                    <TextInput
                                        spellcheck="false"
                                        rows="20"
                                        multiline={true}
                                        fullWidth
                                        id="st26input1"
                                        name="st26input1"
                                        label="Copy and Paste your Tabular sequences here"
                                        variant="outlined"
                                        value={formik.values.st26input1}
                                        onChange={formik.handleChange}
                                        //helperText={formik.errors.st26input1}
                                       //disabled={authInfo && authInfo.redo}
                                    />
                                </div>

                            </Col>

                        </Row>
                        <hr />
                    </Col>
                
                <Col>
                <p className='uploadTextData'> <b id="show-text">Upload .xls (Excel) / .xlsx file</b></p>
                {/* <input type="file" accept= ".xls,.xlsx" onChange={(e) => setFile(e.target.files[0])} /> */}
                <input type="file" accept=".xls,.xlsx" onChange={showfil} />
                
                {!(formik.values.st26input1 && formik.values.st26input1 !== 'undefined')  ? 
                ( <Button
                    className='cancelButtonDisable' color="default" disableRipple={true} variant="contained" >
                        Convert to Fasta
                    </Button>
                ) : (
                    <Button
                    className='accountInfo'
                    color="default"
                    disableRipple={true}
                    variant="contained"
                    onClick={() => handleConvert()}
                    toastRef={toastRef}
                    >
                        Convert to Fasta
                    </Button>
                )} 
                <Button variant="contained" disableRipple={true} color="default" className={classes.buttonStyleCancel} onClick={cncl}>{t('cancel')}</Button>

                </Col>
                
                </Row>
            
                </form>
            }
            
        </div>

    )

}

export default TabularToFasta;
